// custom-overlay-container.ts
import { DestroyRef, inject, Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';
import * as HubSelectors from 'src/app/store/hub.selector';
import { Store } from '@ngrx/store';


@Injectable({ providedIn: 'root' })
export class CustomOverlayContainer extends OverlayContainer {
  private store = inject(Store);

  destroyRef = inject(DestroyRef);

  constructor() {
    const platform = inject(Platform);

    super();
  
    this._platform = platform;
  }

  override _createContainer(): void {
    super._createContainer();
    this.store
      .select(HubSelectors.getHubTheme)
      .subscribe((theme) => {
        if (this._containerElement && theme) {
          this._containerElement.setAttribute('data-theme', theme);
        }
      });
  }
}
